import React from "react";
import { Helmet } from "react-helmet-async";
import { backend } from "../backend";

const SEOTags = ({
  title,
  description,
  canonicalUrl,
  ogImage,
  structuredData = {},
}) => {
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Vakansa",
    url: "https://www.vakansa.se/",
    description:
      "Hyr ut och hyr lokaler i andrahand som kontor, samlingslokaler, biografer, idrottshallar, konferenslokaler och annat via Vakansa",
    inLanguage: "sv-SE",
    publisher: { "@id": "https://www.vakansa.se/#organization" },
    sameAs: [
      "https://www.facebook.com/Vakansa/",
      "https://www.instagram.com/vakansa.se/",
      "https://www.linkedin.com/company/vakansa/",
    ],
  };

  const mergedStructuredData = structuredData
    ? Array.isArray(structuredData)
      ? [defaultStructuredData, ...structuredData]
      : [defaultStructuredData, structuredData]
    : [defaultStructuredData];
  return (
    <Helmet>
      <title>{title}</title>

      {/* Regular Meta Tags */}
      {description && <meta name="description" content={description} />}

      {/* Open Graph Meta Tags */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && (
        <meta property="og:image:alt" content={description || title} />
      )}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Vakansa" />
      <meta property="og:locale" content="sv_SE" />
      {canonicalUrl && (
        <meta property="og:url" content={backend(canonicalUrl)} />
      )}

      {/* Twitter Card Meta Tags */}
      <meta
        name="twitter:card"
        content={ogImage ? "summary_large_image" : "summary"}
      />
      <meta name="twitter:site" content="@Vakansa1" />
      <meta name="twitter:creator" content="@RobinRushdi" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {ogImage && (
        <meta name="twitter:image:alt" content={description || title} />
      )}

      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={backend(canonicalUrl)} />}

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(mergedStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEOTags;
